import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { AuthenticationContext } from '#providers/authentication/Authentication.context.ts';
import type { TAuthenticationContextValue } from '#providers/authentication/Authentication.types.ts';

export const useAuthentication = (): TAuthenticationContextValue =>
  useRequiredContext(
    AuthenticationContext,
    'useAuthentication is only available inside an AuthenticationProvider',
  );
